import { useEffect } from 'react';
import { useContainer, useSingleton, useRefCallback } from '@bydesign-ui/hooks';
import { Drag } from '../../../models/drag';
export function useDrag(element, options) {
  var draggable = options.draggable,
      trigger = options.trigger,
      data = options.data,
      onDragPrepare = options.onDragPrepare,
      onDragStart = options.onDragStart,
      onDragging = options.onDragging,
      onDragEnd = options.onDragEnd,
      onClick = options.onClick;
  var drag = useSingleton(function () {
    return new Drag();
  });
  var elementGetter = useContainer(element);
  var handleDragPrepare = useRefCallback(onDragPrepare);
  var handleDragStart = useRefCallback(onDragStart);
  var handleDragging = useRefCallback(onDragging);
  var handleDragEnd = useRefCallback(onDragEnd);
  var handleClick = useRefCallback(onClick);
  drag.updateOptions({
    draggable: draggable,
    trigger: trigger,
    data: data
  });
  useEffect(function () {
    var elem = elementGetter();

    if (elem == null) {
      return;
    }

    drag.init(elem);
  }, [elementGetter()]);
  useEffect(function () {
    drag.addListener('drag-prepare', handleDragPrepare);
    drag.addListener('drag-start', handleDragStart);
    drag.addListener('dragging', handleDragging);
    drag.addListener('drag-end', handleDragEnd);
    drag.addListener('click', handleClick);
    return function () {
      drag.removeListener('drag-prepare', handleDragPrepare);
      drag.removeListener('drag-start', handleDragStart);
      drag.removeListener('dragging', handleDragging);
      drag.removeListener('drag-end', handleDragEnd);
      drag.removeListener('click', handleClick);
      drag.dispose();
    };
  }, []);
  return drag;
}